<template>
  <div class="wrapper">
    <div >
      <side-bar>
        <template slot="links">
          <sidebar-link v-if="user_livello == 1" to="/amministrazione" name="AMMINISTRAZIONE" icon="tim-icons icon-settings-gear-63"/><!-- -->
          <sidebar-link to="/dashboard-antiriciclaggio" name="ANTIRICICLAGGIO" icon="tim-icons icon-chart-pie-36"/>
          <sidebar-link to="/asseverazioni" name="ASSEVERAZIONI" icon="tim-icons icon-book-bookmark"/>
          <sidebar-link to="/corsi" name="CORSI" icon="tim-icons icon-book-bookmark"/><!-- v-if="user_livello == 1 || user_livello == 2 || user_livello == 3" -->
          <sidebar-link v-if="user_livello == 1 || user_livello == 2 || user_livello == 3" to="/note-credito" name="NOTA DI CREDITO" icon="tim-icons icon-paper"/>
          <!--<sidebar-link to="/dashboard" :name="$t('sidebar.dashboard')" icon="tim-icons icon-chart-pie-36"/>-->
          <sidebar-link to="/dashboard" name="PRATICHE" icon="tim-icons icon-single-02"/>
          <!--<sidebar-link v-if="user_livello == 1 || user_livello == 2 || user_livello == 3" to="/attivita" name="ATTIVITÀ" icon="tim-icons icon-pin"/>--><!-- v-if="user_livello == 1 || user_livello == 2 || user_livello == 3"  -->
          <!--<sidebar-link to="/dashboard-satec" name="SATEC" icon="tim-icons icon-single-02"/>-->
        </template>
      </side-bar>
      <div class="main-panel">
        <top-navbar></top-navbar>
        <dashboard-content @click.native="toggleSidebar">
        </dashboard-content>
        <content-footer></content-footer>
      </div>
    </div>
  </div>
</template>

<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import SidebarLink from '../../components/SidebarPlugin/SidebarLink.vue';
//import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    SidebarLink
    //MobileMenu
  },

  data() {
    return {
      isLogged: localStorage.isLogged,
      user_livello: null
    };
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    main: function() {
      this.user_livello = localStorage.getItem('user_livello');
      console.log(`user_livello = ${this.user_livello}, typeof: ${typeof(this.user_livello)}`);
    }
  },
  mounted: function() {
    this.main();
    console.log("this.isLogged: " + this.isLogged);
  }
};
</script>

<style scoped>

</style>